/* eslint-disable no-bitwise */

export enum ArbetsorderDisabledFlag {
    none = 0,
    sparrad = 1,
    makulerad = 2 << 0
}
